import { motion } from "framer-motion";
import { Globe2, Languages, Building } from "lucide-react";

const countries = [
  { flag: "🇮🇳", name: "India", status: "Live" },
  { flag: "🇦🇪", name: "UAE", status: "Soon" },
  { flag: "🇸🇬", name: "Singapore", status: "Soon" },
  { flag: "🇬🇧", name: "United Kingdom", status: "Soon" },
  { flag: "🇺🇸", name: "United States", status: "Soon" },
  { flag: "🇦🇺", name: "Australia", status: "Soon" },
  { flag: "🇨🇦", name: "Canada", status: "Soon" },
  { flag: "🇸🇦", name: "Saudi Arabia", status: "Soon" },
];

const languages = ["English", "हिन्दी", "मराठी", "தமிழ்", "తెలుగు", "العربية", "Español"];

const GlobalReadyStrip = () => {
  return (
    <section className="py-16 sm:py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-10 items-center">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-pill bg-primary/10 text-primary text-xs font-semibold mb-3">
              <Globe2 className="w-3.5 h-3.5" /> Global Ready
            </span>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4">
              Built for the world, <span className="text-gradient">starting with India</span>
            </h2>
            <p className="text-muted-foreground mb-6 max-w-lg">
              PataKare is architected from day one for international expansion — multi-country, multi-language and ready
              to onboard healthcare ecosystems across continents.
            </p>
            <div className="flex flex-wrap gap-2 mb-6">
              {languages.map((l) => (
                <span key={l} className="inline-flex items-center gap-1 px-3 py-1.5 rounded-pill bg-secondary text-foreground/70 text-xs font-medium">
                  <Languages className="w-3 h-3 text-healing-green" />
                  {l}
                </span>
              ))}
            </div>
            <div className="inline-flex items-center gap-2 text-xs text-muted-foreground">
              <Building className="w-4 h-4 text-primary" />
              International appointment & cross-border consult APIs — opening 2026.
            </div>
          </motion.div>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
            {countries.map((c, i) => (
              <motion.div
                key={c.name}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.04 }}
                className="relative p-4 rounded-2xl bg-card border border-border/60 shadow-card flex flex-col items-center text-center"
              >
                <div className="text-3xl mb-2">{c.flag}</div>
                <div className="text-sm font-semibold text-foreground">{c.name}</div>
                <span
                  className={`mt-2 text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-pill ${
                    c.status === "Live"
                      ? "bg-healing-green/15 text-healing-green"
                      : "bg-secondary text-muted-foreground"
                  }`}
                >
                  {c.status}
                </span>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default GlobalReadyStrip;
